import { Routes } from '@angular/router';
import { canDeactivateFormFn } from '@core/guards';
import { widgetResolverFn } from './resolvers/widget.resolver';

export const widgetManagementRoutes: Routes = [
	{
		path: '',
		data: { breadcrumb: 'WIDGETS.TITLES.BREADCRUMB' },
		loadComponent: () =>
			import('./components/widget-list/widget-list.component').then(
				(component) => component.WidgetListComponent
			)
	},
	{
		path: ':widgetId',
		canDeactivate: [
			(component, currentRoute, currentState, nextState) =>
				canDeactivateFormFn(component.form, {
					componentRef: component,
					nextState
				})
		],
		resolve: { widget: widgetResolverFn },
		loadComponent: () =>
			import('./components/widget-designer/widget-designer.component').then(
				(component) => component.WidgetDesignerComponent
			)
	}
];
